import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaGithub,
  FaLinkedin,
  FaEnvelope,
  FaPhone,
  FaArrowRight,
} from 'react-icons/fa';

import { MANAGEMENT_STANDARDS } from './StandardsSection';

import '../styles/footer.css';

import dolLogo from '../pics/dofcan-logo.png';

const linkedInUrl = 'https://www.linkedin.com';
const githubUrl = 'https://github.com/jgina/Dofan-';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">

        {/* =====================================================
            MAIN FOOTER
        ===================================================== */}
        <div className="footer-main">

          {/* BRAND */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo" aria-label="Dofcan Oilserve Limited Home">
              <img
                src={dolLogo}
                alt="Dofcan Oilserve logo"
                className="footer-logo-image"
              />
            </Link>

            <p>
              Dofcan Oilserve Limited provides training,
              certification, and equipment inspection services
              for the lifting, oil and gas, and industrial sectors.
            </p>

            <p className="footer-brand-note">
              Our services support safer lifting operations,
              professional competence, and reliable certification.
            </p>

            <div className="footer-badges">
              <span>TRAINING</span>
              <span>INSPECTION</span>
              <span>CERTIFICATION</span>
            </div>
          </div>

          {/* SERVICES */}
          <div className="footer-column">
            <h4>Our Services</h4>

            <ul>
              <li>
                <Link to="/services">
                  Mobile Crane Operator Training
                  <FaArrowRight />
                </Link>
              </li>

              <li>
                <Link to="/services">
                  Crane Inspector Certification
                  <FaArrowRight />
                </Link>
              </li>

              <li>
                <Link to="/services">
                  Safe Rigging &amp; Lifting
                  <FaArrowRight />
                </Link>
              </li>

              <li>
                <Link to="/services">
                  Equipment Inspection
                  <FaArrowRight />
                </Link>
              </li>
            </ul>
          </div>

          {/* PLATFORM */}
          <div className="footer-column">
            <h4>Verification Hub</h4>

            <ul>
              <li>
                <Link to="/verify">
                  Verify Certificate
                  <FaArrowRight />
                </Link>
              </li>

              <li>
                <Link to="/gallery">
                  Gallery
                  <FaArrowRight />
                </Link>
              </li>

              <li>
                <Link to="/about">
                  About Dofcan
                  <FaArrowRight />
                </Link>
              </li>
            </ul>

            <div className="footer-verification-note">
              <span className="footer-status-dot"></span>
              Certificate verification available online
            </div>
          </div>

          {/* CONTACT */}
          <div className="footer-column footer-contact">
            <h4>Contact Dofcan</h4>

            <div className="footer-contact-item">
              <span className="footer-contact-icon">
                <FaEnvelope />
              </span>

              <div>
                <small>Email</small>
                <a href="mailto:dofcanoilserve@yahoo.com">
                  dofcanoilserve@yahoo.com
                </a>
              </div>
            </div>

            <div className="footer-contact-item">
              <span className="footer-contact-icon">
                <FaPhone />
              </span>

              <div>
                <small>Phone</small>
                <a href="tel:+2348036726334">
                  +234 (0) 803 672 6334
                </a>
              </div>
            </div>

            <div className="footer-social">
              <span>Connect</span>

              <div className="social-links">
                <a
                  href={linkedInUrl}
                  title="LinkedIn"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="LinkedIn"
                >
                  <FaLinkedin />
                </a>

                <a
                  href={githubUrl}
                  title="GitHub"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="GitHub"
                >
                  <FaGithub />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* =====================================================
            STANDARDS & COMPLIANCE
        ===================================================== */}
        <div className="footer-standards">
          <span className="footer-standards-title">Our Standards</span>

          <ul className="footer-standards-list">
            {MANAGEMENT_STANDARDS.map((standard) => (
              <li key={standard.code}>
                <span className="footer-standards-icon" aria-hidden="true">
                  {standard.icon}
                </span>

                <span className="footer-standards-text">
                  <strong>{standard.code}</strong>
                  <small>{standard.name}</small>
                </span>
              </li>
            ))}
          </ul>
        </div>

        {/* =====================================================
            FOOTER DIVIDER
        ===================================================== */}
        <div className="footer-divider"></div>

        {/* =====================================================
            BOTTOM FOOTER
        ===================================================== */}
        <div className="footer-bottom">

          <div className="footer-copyright">
            <span>
              © 2026 Dofcan Oilserve Limited.
            </span>

            <span>
              All rights reserved.
            </span>

            <span className="footer-separator">•</span>

            <span>
              Certificate verification services provided by
              Dofcan Oilserve.
            </span>
          </div>

          <div className="footer-bottom-links">
            <Link to="/contact">Contact</Link>
            <Link to="/services">Services</Link>
            <Link to="/verify">Verify Certificate</Link>
            <Link to="/admin/login" className="footer-admin-link">
              Admin Login
            </Link>
          </div>

        </div>
      </div>
    </footer>
  );
}